import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { useEffect, useState } from "react";
import { collection, doc, getFirestore, onSnapshot } from "firebase/firestore";
import moment from "moment";

interface sessao {
  idSessao: string;
}
interface parlamentar {
  nome: string;
  partido: string;
  presenca: boolean;
}

interface sessaoDados {
  id: string;
  sessao: string;
  periodo: string;
  tipoSessao: string;
  legislatura: string;
  dataSessao: string;
}
export default function RelatorioPresenca({ idSessao }: sessao) {
  const [presencaParlamentares, setPresencaParlamentares] = useState<
    parlamentar[]
  >([]);
  const [sessao, setSessao] = useState<sessaoDados>();

  useEffect(() => {
    const db = getFirestore();
    const docRef = doc(db, "users", `belacruz@eleg`, "sessoes", `${idSessao}`);

    const unsubscribe = onSnapshot(docRef, (doc) => {
      if (doc.exists()) {
        setSessao(doc.data() as sessaoDados);
      } else {
        console.warn("Documento não encontrado!");
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const db = getFirestore();

    const ordersRef = collection(
      db,
      "users",
      `belacruz@eleg`,
      "sessoes",
      `${idSessao}`,
      "presencaParlamentares"
    );

    onSnapshot(ordersRef, (querySnapshot) => {
      const parsedData = querySnapshot.docs.map((doc) => {
        const data = doc.data();

        return { ...data };
      });

      //@ts-ignore
      function compararTimestamps(a, b) {
        return a.momento - b.momento;
      }

      //@ts-ignore
      setPresencaParlamentares(parsedData.sort(compararTimestamps));
    });
  }, []);

  Font.register({
    family: "DM Sans",
    fonts: [
      {
        src: require("../../assets/fonts/DMSans-Regular.ttf"), // Regular
        fontWeight: "normal",
      },
      {
        src: require("../../assets/fonts/DMSans-Medium.ttf"), // Bold
        fontWeight: "medium",
      },
      {
        src: require("../../assets/fonts/DMSans-Bold.ttf"), // Bold
        fontWeight: "bold",
      },
    ],
  });

  const styles = StyleSheet.create({
    body: {
      padding: 24,
    },
    page: {
      padding: 30,
      fontSize: 10,
    },
    header: {
      textAlign: "center",
      marginBottom: 10,
    },
    headerImage: {},
    table: {
      width: "auto",
      margin: "auto",
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#000",
    },
    tableRow: {
      flexDirection: "row",
    },
    tableCol: {
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#000",
      padding: 3,
    },
    tableCell: {
      margin: "auto",
      textAlign: "center",
    },
    footer: {
      marginTop: 20,
      textAlign: "center",
    },
    ementa: {
      marginTop: 10,
      border: "1px solid #000",
      padding: 5,
    },
  });

  return (
    <Document>
      <Page style={styles.body}>
        <View
          style={{
            width: "100%",
            height: 80,
            borderRadius: 8,
            flexDirection: "row",
            alignItems: "center",
            gap: 10,
          }}
        >
          <Image
            style={{
              width: 60,
              height: 60,
            }}
            src={
              "https://firebasestorage.googleapis.com/v0/b/e-legislacao.appspot.com/o/SIMBOLO%20FUNDO%20TRANSPARENTE.png?alt=media&token=65af9ccc-3753-4380-9f09-486cc929cf34"
            }
          />

          <View>
            <Text
              style={{
                fontSize: 16,
                fontFamily: "DM Sans",
                fontWeight: "bold",
                letterSpacing: -0.5,
              }}
            >
              Câmara Municipal de Bela Cruz
            </Text>
            <Text
              style={{
                fontSize: 10,
                fontFamily: "DM Sans",
                fontWeight: "medium",
                letterSpacing: -0.5,
                color: "#7B849E",
              }}
            >
              Rua 7 de Setembro, 34 - Centro - CEP: 62570000 - Bela Cruz/CE
            </Text>
            <Text
              style={{
                fontSize: 10,
                fontFamily: "DM Sans",
                fontWeight: "medium",
                letterSpacing: -0.5,
                color: "#7B849E",
              }}
            >
              contato@cmbelacruz.ce.gov.br
            </Text>
          </View>
        </View>

        <View
          style={{
            width: "100%",
            borderRadius: 8,
            backgroundColor: "#F9FAFC",
            padding: 16,
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <View
            style={{
              width: "40%",
            }}
          >
            <View
              style={{
                width: "100%",
              }}
            >
              <Text
                style={{
                  fontSize: 10,
                  fontFamily: "DM Sans",
                  fontWeight: "medium",
                  letterSpacing: -0.5,
                  color: "#7B849E",
                }}
              >
                Sessão
              </Text>

              <Text
                style={{
                  fontSize: 10,
                  fontFamily: "DM Sans",
                  fontWeight: "medium",
                  letterSpacing: -0.5,
                  color: "#0B0D1E",
                }}
              >
                {`${sessao?.sessao} Sessão${
                  sessao?.tipoSessao == "ordinaria"
                    ? " Ordinária"
                    : " Extraordinária"
                }`}
              </Text>
            </View>

            <View
              style={{
                width: "100%",
                marginTop: 5,
              }}
            >
              <Text
                style={{
                  fontSize: 10,
                  fontFamily: "DM Sans",
                  fontWeight: "medium",
                  letterSpacing: -0.5,
                  color: "#7B849E",
                }}
              >
                Presidente da Sessão
              </Text>

              <Text
                style={{
                  fontSize: 10,
                  fontFamily: "DM Sans",
                  fontWeight: "medium",
                  letterSpacing: -0.5,
                  color: "#0B0D1E",
                }}
              >
                Carlos Alexandre
              </Text>
            </View>
          </View>

          <View
            style={{
              width: "40%",
            }}
          >
            <View
              style={{
                width: "100%",
              }}
            >
              <Text
                style={{
                  fontSize: 10,
                  fontFamily: "DM Sans",
                  fontWeight: "medium",
                  letterSpacing: -0.5,
                  color: "#7B849E",
                }}
              >
                Data
              </Text>

              <Text
                style={{
                  fontSize: 10,
                  fontFamily: "DM Sans",
                  fontWeight: "medium",
                  letterSpacing: -0.5,
                  color: "#0B0D1E",
                }}
              >
                {moment(new Date(sessao?.dataSessao ?? ""))
                  .add(1, "days")
                  .format("DD/MM/YYYY")}
              </Text>
            </View>

            <View
              style={{
                width: "100%",
                marginTop: 5,
              }}
            >
              <Text
                style={{
                  fontSize: 10,
                  fontFamily: "DM Sans",
                  fontWeight: "medium",
                  letterSpacing: -0.5,
                  color: "#7B849E",
                }}
              >
                Presentes
              </Text>

              <Text
                style={{
                  fontSize: 10,
                  fontFamily: "DM Sans",
                  fontWeight: "medium",
                  letterSpacing: -0.5,
                  color: "#0B0D1E",
                }}
              >
                {presencaParlamentares.filter(
                  (item) => (item as any).presenca === true
                ).length != 0
                  ? `${
                      presencaParlamentares.filter(
                        (item) => (item as any).presenca === true
                      ).length
                    } parlamentares`
                  : "Nenhum"}
              </Text>
            </View>
          </View>
        </View>

        <View
          style={{
            width: "100%",
            marginTop: 10,
          }}
        >
          <View
            style={{
              width: "100%",
              backgroundColor: "#2F73FE",
              borderRadius: 99,
              flexDirection: "row",
            }}
          >
            <View
              style={{
                width: "50%",
                padding: 6,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text
                style={{
                  color: "#f5f5f5",
                  fontSize: 10,
                  letterSpacing: -0.5,
                  fontFamily: "DM Sans",
                  fontWeight: "medium",
                }}
              >
                VEREADOR
              </Text>
            </View>
            <View
              style={{
                width: "25%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text
                style={{
                  color: "#f5f5f5",
                  fontSize: 10,
                  fontFamily: "DM Sans",
                  fontWeight: "medium",
                }}
              >
                PARTIDO
              </Text>
            </View>

            <View
              style={{
                width: "25%",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Text
                style={{
                  color: "#f5f5f5",
                  fontSize: 10,
                  fontFamily: "DM Sans",
                  fontWeight: "medium",
                }}
              >
                PRESENÇA
              </Text>
            </View>
          </View>

          {presencaParlamentares.map((parlamentar, index) => {
            return (
              <View
                key={index}
                style={{
                  width: "100%",
                  flexDirection: "row",
                  alignItems: "center",
                  padding: 8,
                  borderRadius: 6,
                  backgroundColor: index % 2 === 0 ? "#fff" : "#F9FAFC",
                }}
              >
                <View
                  style={{
                    width: "73%",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 9,
                      color: "#000",
                      fontFamily: "DM Sans",
                      fontWeight: "normal",
                    }}
                  >
                    {parlamentar.nome}
                  </Text>
                </View>

                <View
                  style={{
                    width: "25%",
                    alignItems: "flex-start",
                  }}
                >
                  <Text
                    style={{
                      fontSize: 8,
                      fontFamily: "DM Sans",
                      fontWeight: "normal",
                    }}
                  >
                    {parlamentar.partido}
                  </Text>
                </View>

                <View
                  style={{
                    width: "25%",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <View
                    style={{
                      borderRadius: 99,
                      backgroundColor:
                        parlamentar.presenca == true ? "#DCFCE7" : "#FCF4D9",
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 8,
                        fontFamily: "DM Sans",
                        fontWeight: "normal",
                        paddingVertical: 4,
                        paddingHorizontal: 10,
                        color:
                          parlamentar.presenca == true ? "#16A34A" : "#EF9610",
                      }}
                    >
                      {parlamentar.presenca ? "Presente" : "Ausente"}
                    </Text>
                  </View>
                </View>
              </View>
            );
          })}
        </View>

        <View
          style={{
            width: "98%",
            alignSelf: "center",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: 80,
          }}
        >
          <Text
            style={{
              fontSize: 10,
              color: "#000",
              fontFamily: "DM Sans",
              fontWeight: "normal",
            }}
          >
            Ementa:
          </Text>
          <View
            style={{
              borderTopColor: "#7B849E",
              borderTopWidth: 1,
              width: 340,
              alignItems: "center",
              marginTop: 10,
            }}
          >
            <Text
              style={{
                fontSize: 9,
                color: "#0B0D1E",
                fontFamily: "DM Sans",
                fontWeight: "normal",
                marginTop: 5,
              }}
            >
              ( Presidente da Sessão )
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
}

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#E4E4E4",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
});
